import { I18n } from '@calendly/i18n'

import { useHomeTabs } from 'hooks/home/tabs'

import { SearchInput } from './search_input'

export const GroupUsersSearch = ({ selectedIds, setSelectedIds }) => {
  const { getTabScopeV1 } = useHomeTabs()
  const { id: groupId } = getTabScopeV1()

  return (
    <SearchInput
      title={I18n.t('publisher.event_types.filters.titles.group_users')}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      searchParams={{ groupId }}
    />
  )
}
